import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-editt",
  "use": "icon-editt-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-editt\"><defs><clipPath id=\"icon-editt_a\"><path data-name=\"矩形 295\" transform=\"translate(1216 291)\" d=\"M0 0h12v12H0z\" /></clipPath></defs><g transform=\"translate(-1216 -291)\" clip-path=\"url(#icon-editt_a)\"><path data-name=\"编辑 (1)\" d=\"M1224.909 294.497l-1.871-1.874-5.021 5.021v1.874h1.874l5.018-5.021zm1.473-1.473a.525.525 0 0 0 0-.736l-1.135-1.134a.525.525 0 0 0-.738 0l-1 1 1.874 1.874zm-10.373 7.967h11.983v2.008h-11.983z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol